var _style, _path, _path2, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDragon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 72 72",
    style: {
      enableBackground: "new 0 0 72 72"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#Rectangle-2_1_);}\r\n\t.st1{fill:#FFFFFF;}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "Types_Dragon",
    transform: "translate(10 10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -15, -15)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Rectangle-2_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 10.6667,
    y1: 61.5333,
    x2: 10.6667,
    y2: 59.1645,
    gradientTransform: "matrix(30 0 0 -30 -284 1846)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0C69C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0180C7"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-2",
    className: "st0",
    d: "M36,0L36,0c19.9,0,36,16.1,36,36l0,0c0,19.9-16.1,36-36,36l0,0C16.1,72,0,55.9,0,36l0,0 C0,16.1,16.1,0,36,0z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Oval_8",
    className: "st1",
    d: "M22.1,39.2c-3.4,0-6.7-1.1-9.4-3.1c-2.6-1.9-4.6-4.7-5.6-7.8c0-0.2-0.1-0.4-0.1-0.6 c-0.2-1.3-0.2-2,0-2.3c0,0,0.1-0.1,0.2-0.1c0,0,0.1,0,0.1,0c0.3,0.4,0.5,0.8,0.7,1.3c0.3,0.7,0.6,1.5,1,2.2c0.4,0.8,1,1.6,1.8,2.1 c0,0,0,0,0,0c-0.1-0.3-0.3-0.6-0.5-0.8c-0.2-0.3-0.4-0.6-0.6-1c-0.4-0.7-0.6-1.2-0.5-1.5c0-0.1,0.1-0.1,0.1-0.1h0.1 c0.3,0,0.8,0.6,1.4,1.4l0,0c0.3,0.4,0.6,0.8,1,1.1c0.5,0.7,1.2,1.2,2,1.6c0,0,0,0,0,0c0,0,0,0,0,0c0-0.1-0.2-0.4-0.5-0.8 c-0.2-0.2-0.3-0.5-0.4-0.7l0,0c-0.3-0.6-0.6-1-0.3-1.2c0,0,0.1,0,0.1,0c0.3,0,0.8,0.4,1.4,0.9l0.2,0.2l0,0 c0.4,0.4,0.7,0.7,0.9,0.7c0,0,0,0,0.1,0c0.1-0.1,0-0.3,0-0.6c-0.1-0.2-0.2-0.5-0.1-0.7c0.1-0.1,0.2-0.1,0.3-0.1h0 c0.3,0.1,0.5,0.2,0.7,0.3l0,0c0.2,0.1,0.5,0.3,0.9,0.5c1.1,0.8,2.5,1.3,3.9,1.3c3.5,0,6.4-2.8,6.5-6.3c0-2.6-1.6-4.9-4-5.9 c-0.1,0.3-0.4,0.6-0.7,0.9c-0.3,0.2-0.7,0.4-1.1,0.4c-0.2,0-0.4,0.1-0.8,0.1c-1.2,0.2-15.1,3.4-15.2,3.5c0,0-0.1,0-0.3,0 c-0.4,0-0.9-0.1-1.2-0.4C3.9,23.2,5.1,21,5.1,21c1.4-2.7,3-5.3,4.8-7.8c0.1-0.1,0.6-0.5,1.3-1c1.5-1.1,4-2.9,6.5-5.1 c1.6-1.4,3.2-2.9,4.6-4.6c0.2-0.2,0.3-0.4,0.5-0.7c0.4-0.6,0.7-1.1,1.4-1.1c0.3,0,0.6,0.1,0.8,0.3c0.4,0.5,0.3,1.4,0.3,2 c0,0.1,0,0.1,0,0.2c-0.4,1.4-0.9,2.8-1.5,4.2c-0.1,0.4-0.2,0.8-0.2,1.1c3.9,0.3,7.6,2,10.2,4.9c2.7,2.8,4.2,6.5,4.2,10.4 C37.7,32.4,30.7,39.3,22.1,39.2z M11,18.2c0,0,0.1,0,0.2,0c1.2,0.1,2.4-0.3,3.4-1.1c0.8-0.9,1.1-2.1,1-3.3 c-0.9,0.6-1.8,1.2-2.6,1.9C12.3,16.6,11.7,17.4,11,18.2L11,18.2z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragon);
export default __webpack_public_path__ + "static/media/dragon.fff104d2e169966899f7df50333f6434.svg";
export { ForwardRef as ReactComponent };